import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=c486ea1e&scoped=true"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=ts"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c486ea1e",
  null
  
)

export default component.exports